export enum RelatedResourceType {
    DOCUMENT = "DOCUMENT",
    CATEGORY = "CATEGORY",
}
